import React from "react";
import moment from "moment";
import { formatWrittenDateTimeUtc } from "utilities";
import LinkedShowLines from "components/LinkedShows/LinkedShowElement";
import { ShowPreview } from "components/PreviewPanel/Show/ShowPreviewPanel";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";

interface Props {
  bookingRequest: server.dto.ShowFromWebform
  onShowChange: () => void
}

class BookingRequestRowCard extends React.Component<Props> {
  public render(): JSX.Element {
    const item = this.props.bookingRequest;

    const createdMoment = moment.utc(item.createdUtc);

    return (
      <div className="hoverable">
        <ShowPreview
          canEdit={false}
          showId={item.showId}
          onChange={this.props.onShowChange}
          trigger={
            <>
              <div className="grow1 flex-column gap-small">
                <LinkedShowLines
                  dateTime={item.dateTime}
                  eventDescription={item.eventDescription}
                  venueDescription={item.venueDescription}
                  format="big" />

                <div className="s1_smaller" title={formatWrittenDateTimeUtc(createdMoment)}>{createdMoment.fromNow()}</div>
              </div>
              <div>
                <PhosphorWarning iconSize="large" />
              </div>
            </>
          }
        />
      </div>
    );
  }
}

export default BookingRequestRowCard;
